var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const EventBus = require('@vertx/eventbus-bridge-client.js');
/**
 * The update type.
 */
export var UpdateType;
(function (UpdateType) {
    UpdateType["POST"] = "POST";
    UpdateType["PUT"] = "PUT";
    UpdateType["DELETE"] = "DELETE";
})(UpdateType || (UpdateType = {}));
/**
 * A client to communicate with the event bus.
 */
export class Client {
    /**
     * @param url the url used to connect to the event bus
     * @param token the authentication token
     * @param company the client's company
     * @param options the client's options. Optional
     */
    constructor(url, token, company, options) {
        this.url = `${url}?token=${token}`;
        this.company = company;
        this.options = options;
        this.onItemUpdateCallback = null;
    }
    /**
     * Connects the client to the event bus.
     *
     * @return a Promise that completes when the connection is established
     */
    connect() {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                try {
                    const options = this.options && {
                        vertxbus_ping_interval: this.options.pingInterval,
                        vertxbus_reconnect_attempts_max: this.options.maxReconnectAttempts,
                        vertxbus_reconnect_delay_min: this.options.minReconnectDelay,
                        vertxbus_reconnect_delay_max: this.options.maxReconnectDelay,
                        vertxbus_reconnect_exponent: this.options.reconnectExponentialBackoffFactor,
                        vertxbus_randomization_factor: this.options.randomizationFactor,
                    };
                    this.bus = new EventBus(this.url, options);
                    this.bus.enableReconnect(true);
                    this.bus.onopen = () => {
                        this.bus.registerHandler(`items.updates.${this.company}`, (error, message) => {
                            const body = message.body;
                            if (this.onItemUpdateCallback) {
                                this.onItemUpdateCallback(body.type, body.id, body.content, error);
                            }
                            else {
                                console.error('No callback was registered for item update');
                            }
                        });
                        resolve();
                    };
                }
                catch (error) {
                    reject(error);
                }
            });
        });
    }
    /**
     * Disconnects the client.
     */
    disconnect() {
        if (this.bus) {
            this.bus.close();
        }
        else {
            console.error('The client is not connected');
        }
    }
    /**
     * Registers a callback to be called on item update.
     *
     * @param callback the callback to invoke
     */
    onItemUpdate(callback) {
        this.onItemUpdateCallback = callback;
    }
}
//# sourceMappingURL=client.js.map